import bemBlock from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import type { UIGradient } from "@gik/ui-legacy/types";
import React from "react";
import { MarketingNav } from "./MarketingNav";

interface MarketingNavSectionProps {
	variant?: UIGradient;
}

function MarketingNavSectionComp({
	variant = "neutral",
}: MarketingNavSectionProps): React.ReactElement {
	const bem = bemBlock("marketing-nav-hero");
	return (
		<PageSection variant={variant} className={bem()}>
			<MarketingNav />
		</PageSection>
	);
}

export const MarketingNavSection = React.memo(
	withComponentErrorBoundary(MarketingNavSectionComp),
);
